const index = {
    state:     {
        batchPayments:    [],
        depositBatches:   [],
        creditTotal:      0,
        cashTotal:        0,
        checksTotal:      0,
        ccTotal:          0,
        achTotal:         0,
        endingTill:       0,
        cashCount:        0,
        cashDeposit:      0,
        shortTill:        0,
        note:             "",
        selectedFacility: {'id': null}
    },
    getters:   {
        batchPayments:    () => {
            return state.paymentsBatch;
        },
        depositBatches:   () => {
            return state.depositBatches
        },
        creditTotal:      (state) => {
            return state.creditTotal;
        },
        cashTotal:        (state) => {
            return state.cashTotal;
        },
        checksTotal:      (state) => {
            return state.checksTotal;
        },
        ccTotal:          (state) => {
            return state.ccTotal;
        },
        achTotal:         (state) => {
            return state.achTotal;
        },
        endingTill:       (state) => {
            return state.endingTill;
        },
        cashCount:        (state) => {
            return state.cashCount;
        },
        cashDeposit:      (state) => {
            return state.cashDeposit;
        },
        shortTill:        (state) => {
            return state.shortTill;
        },
        note:             (state) => {
            return state.shortTill;
        },
        selectedFacility: (state) => {
            return state.selectedFacility;
        }
    },
    mutations: {
        set_cashTotal:       (state, payload) => (state.cashTotal = payload),
        set_creditTotal:     (state, payload) => (state.creditTotal = payload),
        set_ccTotal:         (state, payload) => (state.ccTotal = payload),
        set_achTotal:        (state, payload) => (state.achTotal = payload),
        set_checksTotal:     (state, payload) => (state.checksTotal = payload),
        set_endingTill:      (state, payload) => (state.endingTill = payload),
        set_cashCount:       (state, payload) => (state.cashCount = payload),
        set_cashDeposit:     (state, payload) => (state.cashDeposit = payload),
        set_shortTill:       (state, payload) => (state.shortTill = payload),
        set_note:            (state, payload) => (state.note = payload),
        setBatchPayments:    (state, payload) => {
            state.batchPayments = payload.filter(payment => payment.payment_type_id === 3 && payment.batch_id || (payment.payment_type_id !== 3));

                // payment.payment_type_id !== 3 || payment.payment_type_id === 3 && payment.batch_id);
            //set Totals when Batch Payments change
            state.creditTotal   = 0;
            state.cashTotal     = 0;
            state.checksTotal   = 0;
            state.ccTotal       = 0;
            state.achTotal      = 0;

            //TODO this code is duplicated in the setTotals commit below for dev time's sake. Better if we didn't duplicate the code and rethink this process.
                state.batchPayments.forEach((payment) => {
                    switch (payment.payment_type_id) {
                        case 1:
                            state.creditTotal += payment.amount;
                            break;
                        case 2:
                            state.cashTotal += payment.amount;
                            break;
                        case 3:
                            state.checksTotal += payment.amount;
                            break;
                        case 4:
                            state.ccTotal += payment.amount;
                            break;
                        case 5:
                            state.achTotal += payment.amount;
                            break;
                        default:
                            state.creditTotal += payment.amount;
                    }
                });
        },

        setDepositBatches:   (state, payload) => {
            state.depositBatches = payload;
        },
        setSelectedFacility: (state, payload) => {
            state.selectedFacility = payload;
        },
        setTotals: (state) => {
            state.batchPayments.forEach((payment) => {
                switch (payment.payment_type_id) {
                    case 1:
                        state.creditTotal += payment.amount;
                        break;
                    case 2:
                        state.cashTotal += payment.amount;
                        break;
                    case 3:
                        state.checksTotal += payment.amount;
                        break;
                    case 4:
                        state.ccTotal += payment.amount;
                        break;
                    case 5:
                        state.achTotal += payment.amount;
                        break;
                    default:
                        state.creditTotal += payment.amount;
                }
            });
        },
    }
}

export default index;

